import { CSSProperties } from 'react';
import RichText from '../RichText/RichText';

import { Elements } from '@kontent-ai/delivery-sdk';
import {
  calculateRemainingTime,
  getTimeText,
  getProjectType,
  ProjectTypes,
} from '@r-and-a-shared-ui/utils';

import stylesPP from './scss/AlertBarPP.module.scss';
import stylesMMB from './scss/AlertBarMMB.module.scss';

export interface AlertBarProps {
  text?: Elements.RichTextElement;
  countdown?: string | null;
  daysLabel?: string;
  dayLabel?: string;
  hoursLabel?: string;
  hourLabel?: string;
  minutesLabel?: string;
  minuteLabel?: string;
  backgroundColor?: string;
  textColor?: string;
  textFont?: string;
  backgroundImage?: string;
  kontentItemId?: string;
}

export function AlertBar(props: AlertBarProps) {
  const {
    text,
    countdown,
    daysLabel,
    dayLabel,
    minutesLabel,
    minuteLabel,
    hoursLabel,
    hourLabel,
    backgroundColor,
    textColor,
    textFont,
    backgroundImage,
    kontentItemId,
  } = props;

  const projectType = getProjectType();
  const isPPproject = projectType === ProjectTypes.PlayerPortals;

  const styles = isPPproject ? stylesPP : stylesMMB;

  const inlineStylePP: CSSProperties = {
    backgroundColor,
    color: textColor,
    backgroundImage: backgroundImage && `url(${backgroundImage})`,
  };

  const inlineStyleMMB: CSSProperties = {
    backgroundColor,
    color: textColor,
    fontFamily: textFont,
    backgroundImage: backgroundImage && `url(${backgroundImage})`,
  };

  const inlineStyle = isPPproject ? inlineStylePP : inlineStyleMMB;

  const {
    days = undefined,
    hours = undefined,
    minutes = undefined,
  } = countdown ? calculateRemainingTime(countdown) : {};

  const isCountdownExpired =
    days !== undefined &&
    hours !== undefined &&
    minutes !== undefined &&
    days <= 0 &&
    hours <= 0 &&
    minutes <= 0;

  const daysTextValue = getTimeText(days, dayLabel, daysLabel, 'day/s');
  const hoursTextValue = getTimeText(hours, hourLabel, hoursLabel, 'hour/s');
  const minutesTextValue = getTimeText(
    minutes,
    minuteLabel,
    minutesLabel,
    'minute/s',
  );

  return (
    <div
      className={styles['alert-bar']}
      style={inlineStyle}
      suppressHydrationWarning
      data-kontent-item-id={kontentItemId}
    >
      <RichText content={text} />
      {props.countdown && !isCountdownExpired ? (
        <>
          <b>
            {'\u00A0'}
            {daysTextValue} {hoursTextValue} {minutesTextValue}
          </b>
        </>
      ) : null}
    </div>
  );
}

export default AlertBar;
